import Login from '../../pages/login/index.vue'
import Register from '../../pages/login/register.vue'

// auth 页面路由：统一公开路径及路由名称，组件和 meta 保持不变。
const routes = [
  { path: '/auth/login', name: 'auth-login', component: Login, meta: { title: '', public: true } , pathToRegexpOptions: { sensitive: true }},
  { path: '/auth/register', name: 'auth-register', component: Register, meta: { title: '', public: true } , pathToRegexpOptions: { sensitive: true }},
]

export default routes
